import HorizontalScrollView from "./HorizontalScrollView";
export default HorizontalScrollView;
